'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (typeof document !== 'undefined') {
		if (document.contains) {
			return document.contains;
		}
		if (document.body && document.body.contains) {
			try {
				if (typeof document.body.contains.call(document, '') === 'boolean') {
					return document.body.contains;
				}
			} catch (e) { /**/ }
		}
	}
	return implementation;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/document.contains/polyfill.js
 ** module id = 412
 ** module chunks = 0
 **/